import axios from 'axios';
import Loader from 'react-loader-spinner';
import { useHistory } from 'react-router';
import React, { useState, useEffect, useCallback } from 'react';

import './style.css';
import Pagination from '../Pagination';

const baseUrl = process.env.REACT_APP_BASE_URL;

const SponsoredChildren = () => {
  const history = useHistory();

  const [sponsoredKids, setSponsoredKids] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);
  const [pagination, setPagination] = useState({
    totalPages: null,
    currentPage: null,
    hasPrevPage: null,
    hasNextPage: null,
    nextPage: null,
    prevPage: null,
  });

  const fetchKids = useCallback((page) => {
    setLoading(true);

    axios
      .get(`${baseUrl}/sponsored-kid?page=${page}`)
      .then((res) => {
        let imagesArr = [];

        const {
          totalPages,
          page,
          hasPrevPage,
          hasNextPage,
          nextPage,
          prevPage,
          docs,
        } = res.data.data;

        setPagination({
          totalPages,
          currentPage: page,
          hasPrevPage,
          hasNextPage,
          nextPage,
          prevPage,
        });

        docs.map((item) => {
          return (imagesArr = [
            ...imagesArr,
            {
              src: item.image,
              title: item.title,
              width: 4,
              height: 3,
            },
          ]);
        });

        setSponsoredKids(docs);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setLoadingError(true);
      });
  }, []);

  useEffect(() => {
    fetchKids(1);
  }, [fetchKids]);

  return (
    <div className="wpo-about-area section-padding">
      <div className="container">
        <div className="row">
          {loading ? (
            <div className="result-container">
              <Loader type="Oval" color="#d90404" height={80} width={80} />
            </div>
          ) : loadingError ? (
            <div className="result-container">
              <p>
                Could not fetch sponsored children. Refresh or check back later.
              </p>
            </div>
          ) : !sponsoredKids.length ? (
            <div className="result-container">
              <p>No sponsored children. Check back later.</p>
            </div>
          ) : (
            <div className="col-lg-12 col-md-12 colsm-12">
              <div className="wpo-sponsored-kid-text">
                <h2 className="pb-4">Sponsor an African Child</h2>
                <p>
                  The following are children that you can sponsor in Africa.
                </p>
                <div className="row">
                  {sponsoredKids.map((kid) => (
                    <div
                      key={kid._id}
                      className="col-lg-4 col-md-6 col-sm-12 col-12"
                    >
                      <div className="info-item">
                        <img
                          src={kid.image}
                          alt={kid.firstName}
                          className="pb-4"
                        />
                        <h2>{kid.firstName + ' ' + kid.lastName}</h2>
                        <div className="info-wrap">
                          <div className="info-text">
                            <p>
                              Age -{' '}
                              {new Date().getFullYear() -
                                new Date(kid.dateOfBirth).getFullYear()}{' '}
                              Years Old
                            </p>
                            <p> Country - {kid.country}</p>
                          </div>
                          <button
                            className="theme-btn-s2"
                            onClick={() =>
                              history.push(
                                `/donate?firstName=${kid.firstName}&lastName=${kid.lastName}&code=${kid._id}`
                              )
                            }
                          >
                            Sponsor
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {pagination.totalPages > 1 && (
                  <Pagination
                    paginationDetails={pagination}
                    fetchMore={fetchKids}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SponsoredChildren;
